<nav class="my-hr-nav" aria-label="My HR navigation">
  @for (item of items; track item.route) {
    <a
      class="my-hr-nav-link"
      [routerLink]="item.route"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: item.route === '/my-hr' }">
      <span class="nav-icon">
        <i [class]="item.icon"></i>
      </span>
      <span class="nav-label">{{ item.label }}</span>
      @if ((item.badge ?? 0) > 0) {
        <p-tag [value]="item.badge + ''" severity="info"></p-tag>
      }
    </a>
  }
</nav>
